import { useEffect, useRef, useState } from "react";
import { NavLink, Outlet, useLocation, useOutletContext } from "react-router-dom";
import { TabNames } from "../Assets/variables";
import { capitalizeWord, parseApiPropertiesByPath } from "../Utils/contentTransformers";
import { apisv2 } from "../Assets/API/apisv2";
import CertificationAlert from "./CertificationAlert";

const APIQueryBuilder = () => {
    const {setActiveTabItem, apiInfo} = useOutletContext();
    const location = useLocation();
    const activeEndpoint = location.pathname.split("/").slice(-1)[0] || "instruments";
    const propertiesRef = useRef(parseApiPropertiesByPath(apisv2[apiInfo.apiName]));
    let currentEndpoint = Object.keys(propertiesRef.current).filter((endpoint) => endpoint.split("/").slice(-1)[0] === activeEndpoint)[0];
    const endpointProperties = propertiesRef.current[currentEndpoint] ?? {};
    const { ["Page ID"]: _removedPageId, ["Size"]: _removedSize, ...propertiesByEndpoint } = endpointProperties;
    let endpointUrls = Object.keys(propertiesRef.current);
    let endpointInfos = {};

    endpointUrls = endpointUrls.map((endpoint) => endpoint.split("/").slice(-1)[0]);
    endpointUrls.forEach((endpoint) => {
        endpointInfos[endpoint] = {
            url: endpoint,
            displayName: `${capitalizeWord(endpoint)} Search Criteria`
        }
    });

    const setActiveEndpointTab = (_endpoint = "") => {};

    useEffect(() => {
        setActiveTabItem(TabNames.QueryBuilder);
    }, []);
    
    return (
        <>
            <div id="tab-explore" className="api-panel">
                <div className="tab-explore__content">
                    <div className="tab-explore__info">
                        <CertificationAlert />
                    </div>
                    <div id="explore-tab-group" className="tabs">
                        { Object.values(endpointInfos).map(endpointInfo => (
                            <NavLink
                                to={endpointInfo.url}
                                key={endpointInfo.url}
                                className={({ isActive }) => `api-tabs-tab ${isActive || endpointInfo.url === activeEndpoint ? "active" : ""}`}>
                                    {`${capitalizeWord(endpointInfo.url)}`}
                            </NavLink>
                        )) }
                    </div>
                    <div className="tab-explore__outlet">
                        <Outlet context={{ setActiveEndpointTab, endpointInfos, propertiesByEndpoint }} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default APIQueryBuilder;